import { GuidedDraggingTool } from '@y42/gojs';
import { Diagram, GraphObject, Layout, Margin, TreeLayout } from 'gojs';
import { dataLineageDiagramConfig } from '../../../state/data-lineage-diagram';
import {
  createGroupTemplateMap,
  createLinkTemplateMap,
  createNodeTemplateMap,
} from './templates/category-template-maps';

const $ = GraphObject.make;

export const createDataLineageDiagram = (props?: Record<string, unknown>): Diagram => {
  const diagram = $(Diagram, {
    padding: new Margin(30),
    scale: dataLineageDiagramConfig.defaultScale,
    linkTemplateMap: createLinkTemplateMap(),
    nodeTemplateMap: createNodeTemplateMap(),
    groupTemplateMap: createGroupTemplateMap(),
    draggingTool: $(GuidedDraggingTool, {
      isComplexRoutingRealtime: false,
      guidelineWidth: 1,
      isGuidelineEnabled: false,
    }),
    scrollMode: Diagram.InfiniteScroll,
    ...props,
  });

  diagram.undoManager.isEnabled = true;
  diagram.animationManager.isEnabled = true;
  diagram.toolManager.hoverDelay = 10;
  diagram.toolManager.toolTipDuration = 10000;

  return diagram;
};

export const lineageDefaultLayout = () => $(TreeLayout);

export const lineageSnapshotLayout = () => $(Layout);
